import React from "react"

import PropTypes from "prop-types"
import {Helmet} from "react-helmet-async"
import {useSelector} from "react-redux"

/**
 * Permet de definir dynamiquement le titre de la page en cours (titre affiché dans l'onglet du navigateur)
 */
const PageTitle = ({actualPageSelector, defaultTitle, pagesArchitecture, prefix = "", suffix = ""}) => {
    const actualPage = useSelector(actualPageSelector)
    const pageConfig = actualPage && pagesArchitecture?.[actualPage]
    const title = pageConfig?.title ?? pageConfig?.breadcrumbText

    return (
        <Helmet>
            <title>{title ? `${prefix}${title}${suffix}` : defaultTitle}</title>
        </Helmet>
    )
}

PageTitle.propTypes = {
    actualPageSelector: PropTypes.func.isRequired,
    defaultTitle: PropTypes.string.isRequired,
    pagesArchitecture: PropTypes.object.isRequired,
    prefix: PropTypes.string,
    suffix: PropTypes.string,
}

export default PageTitle
